<template lang="pug">
header.detail-header
	router-link.detail-return(
		:to="{ path: '/' }", 
		:style="styles.primary.color",
		data-text="Back to Search Results") Back to Search Results
	h1.detail-title(:style="styles.primary.color") {{ title }}
	.detail-headerMeta
		p.detail-size(v-if="sqft != ''") {{ sqft }}
		p.detail-avail(:class="availability.AvStatus") 
			span
			| {{ availability.AvText }}
</template>

<script>
import Theme from '@/listing-app/mixins/Theme'
export default {
	name: "Header",
	mixins: [Theme],
  props: ["title", "sqft", "availability"]
}
</script>


<style lang="scss" scoped>
.detail-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.detail-return {
  margin: 0 0 10px;
  padding: 5px 10px;
  text-decoration: none;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  transition: 0.25s ease;
	color: $mediumLightGray;
  font-size: 0;
	font-family: HelveticaNeueW02-57Cn;
  &:after {
    content: attr(data-text);
    font-size: 18px;
    color: $mediumGray;
  }
  &:before {
    margin-right: 4px;
    height: 12px;
    width: 12px;
    display: block;
    transform: rotate(45deg);
    content: "";
    border-left: 2px solid $mediumGray;
    border-bottom: 2px solid $mediumGray;
  }
  &:hover {
    background: currentColor;
    &:before {
      border-left: 2px solid $white;
      border-bottom: 2px solid $white;
    }
    &:after {
      color: $white;
    }
  }
}

.detail-title {
  margin: 0 0 5px;
}

.detail-headerMeta {
  display: flex;
}

.detail-size {
  margin-right: 10px;
	font-size: 1.125rem;
	font-family: HelveticaNeueW02-57Cn;
}

.detail-avail {
  margin: 15px 0;
	font-family: HelveticaNeueW02-57Cn;
  font-size: 16px;
  display: flex;
	position: relative;
	align-items: center;
  span {
    display: block;
    position: relative;
    padding-left: 30px;
		height: 30px;
		width: 30px;
  }
  &.available {
    color: $green;
    span {
      &:before {
        content: "";
        height: 12px;
        width: 6px;
        border-right: 2px solid;
        border-bottom: 2px solid;
        transform: rotate(45deg);
        left: 8px;
        top: -2px;
        bottom: 0;
        margin: auto 0;
        position: absolute;
      }
      &:after {
        height: 22px;
        width: 22px;
        border: 2px solid;
        border-radius: 50%;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto 0;
        position: absolute;
        content: "";
      }
    }
  }
  &.limitedavailability {
    color: $blue;
    span {
      border: 3px solid currentColor;
      height: 25px;
      width: 25px;
      padding-left: 0;
      border-radius: 50%;
      display: block;
      margin-right: 7px;
      &:before {
        content: "";
        position: absolute;
        height: 8px;
        width: 2px;
        top: 1px;
        left: 0;
        right: 1px;
        bottom: 0;
        border-radius: 1.5px 1.5px 0 0;
        margin: auto;
        display: block;
        background: currentColor;
        transform: translateY(-2px);
      }
      &:after {
        content: "";
        position: absolute;
        width: 6px;
        height: 2px;
        top: 1px;
        left: 0;
        right: 1px;
        bottom: 0;
        margin: auto;
        display: block;
        border-radius: 0 1.5px 1.5px 0;
        background: currentColor;
        transform: rotate(45deg);
        transform-origin: 0% 250%;
      }
    }
  }
  &.waitlist {
		height: 30px;
    color: $orange;
    span {
			margin-right: 5px;
      &:before {
        content: "";
        border-bottom: 26px solid;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        left: 0;
        top: 0;
        bottom: 4px;
        margin: auto 0;
        position: absolute;
      }
      &:after {
        left: 50%;
        top: 0;
        bottom: 0;
				position: absolute;
				font-weight: 900;
        content: "!";
				color: $white;
				transform: translateX(-50%);
				line-height: 30px;
				vertical-align: middle;
        z-index: 2;
				font-size: 17px;
      }
    }
  }
  &.soldout {
    color: $redLight;
    span {
      padding-left: 25px;
      &:before,
      &:after {
        content: "";
        height: 2px;
        width: 20px;
        background: currentColor;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        margin: auto 0;
        transform: rotate(45deg);
      }
      &:after {
        transform: rotate(-45deg);
      }
    }
  }
}
</style>
